import { html } from "src/components/HtmlViewer/utils";
import * as GQL from "src/types/graphql";

export const OFFER_ACCEPTED = {
  type: GQL.message_template_type_enum.OfferAccepted,
  emailSubject:
    "You have accepted an offer from {{offer.schoolName}}! / ¡Ha aceptado una oferta de {{offer.schoolName}}!",
  emailHtml: html`<p>
      Dear {{parent.name}},<br />
      <br />
      You have accepted an offer from {{offer.schoolName}} for {{student.name}},
      for grade {{grade}} for the {{enrollmentPeriod.name}}!<br />
      <br />
      You can review the status of {{student.name}}'s form anytime:
      {{applyUrl}}<br />
      <br />
      If you need help, please contact {{organization.name}}.<br />
      <br />
      -{{organization.name}} Team<br />
    </p>
    <p>_____________________________________________</p>
    <p>
      Estimado/a {{parent.name}},<br />
      <br />
      ¡Ha aceptado una oferta de {{offer.schoolName}} para {{student.name}},
      para el grado {{grade}} para el {{enrollmentPeriod.name}}!<br />
      <br />
      Puede revisar el estado de la aplicación de {{student.name}} en cualquier
      momento: {{applyUrl}}<br />
      <br />
      Si necesita ayuda, por favor contacte a {{organization.name}}.<br />
      <br />
      -Equipo de {{organization.name}}<br />
    </p>`,
  emailText: `Dear {{parent.name}},

You have accepted an offer from {{offer.schoolName}} for {{student.name}}, for grade {{grade}} for the {{enrollmentPeriod.name}}!

You can review the status of {{student.name}}'s form anytime: {{applyUrl}}

If you need help, please contact {{organization.name}}.

-{{organization.name}} Team

_____________________________________________

Estimado/a {{parent.name}},

¡Ha aceptado una oferta de {{offer.schoolName}} para {{student.name}}, para el grado {{grade}} para el {{enrollmentPeriod.name}}!

Puede revisar el estado de la aplicación de {{student.name}} en cualquier momento: {{applyUrl}}

Si necesita ayuda, por favor contacte a {{organization.name}}.

-Equipo de {{organization.name}}`,
  sms: "You have accepted an offer from {{offer.schoolName}}! / ¡Ha aceptado una oferta de {{offer.schoolName}}!",
};
